import { useContext } from "react";
import { LoadingContext, LoadingContextType } from "../utilities/customHooks";
import { Loader2 } from "lucide-react";

const LoadingOverlay = () => {
  const { loadingState } = useContext(LoadingContext) as LoadingContextType;

  if (!loadingState) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/60 backdrop-blur-sm cursor-wait">
      <Loader2 className="h-10 w-10 animate-spin text-primary" />
    </div>
  );
};

export default LoadingOverlay;
